export enum RafflingVariant {
  SCORE = 'score',
  TOP_PLAYER_COUNT = 'top',
  REFERRER_COUNT = 'referrers',
  PROBABILITY_PERCENT = 'probabilityPercent',
  LEADERBOARD = 'leaderboardPlace',
  GAME_RESULT = 'result',
  ADVENT_CALENDAR_DAYS = 'adventCalendarDays'
}
